@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.multiplatform.kotfolio.layout.NeoLayout as _org_multiplatform_kotfolio_layout_NeoLayout
import org.multiplatform.kotfolio.layout.PageLayout as _org_multiplatform_kotfolio_layout_PageLayout
import org.multiplatform.kotfolio.pages.APICallingKtorFitPage as _org_multiplatform_kotfolio_pages_APICallingKtorFitPage
import org.multiplatform.kotfolio.pages.APICallingRPCPage as _org_multiplatform_kotfolio_pages_APICallingRPCPage
import org.multiplatform.kotfolio.pages.BasicPropertiesSwiftUIPage as _org_multiplatform_kotfolio_pages_BasicPropertiesSwiftUIPage
import org.multiplatform.kotfolio.pages.BasicWasmJsPage as _org_multiplatform_kotfolio_pages_BasicWasmJsPage
import org.multiplatform.kotfolio.pages.BasicWasmPage as _org_multiplatform_kotfolio_pages_BasicWasmPage
import org.multiplatform.kotfolio.pages.BusinessTravelPage as _org_multiplatform_kotfolio_pages_BusinessTravelPage
import org.multiplatform.kotfolio.pages.ConstraintLogin as _org_multiplatform_kotfolio_pages_ConstraintLogin
import org.multiplatform.kotfolio.pages.ExposedBackendPage as _org_multiplatform_kotfolio_pages_ExposedBackendPage
import org.multiplatform.kotfolio.pages.HiltDiPage as _org_multiplatform_kotfolio_pages_HiltDiPage
import org.multiplatform.kotfolio.pages.KTORPage as _org_multiplatform_kotfolio_pages_KTORPage
import org.multiplatform.kotfolio.pages.KoTestPage as _org_multiplatform_kotfolio_pages_KoTestPage
import org.multiplatform.kotfolio.pages.KotlinInjectDiPage as _org_multiplatform_kotfolio_pages_KotlinInjectDiPage
import org.multiplatform.kotfolio.pages.MetroDependencyInjectionPage as _org_multiplatform_kotfolio_pages_MetroDependencyInjectionPage
import org.multiplatform.kotfolio.pages.NoteBookKotlinPage as _org_multiplatform_kotfolio_pages_NoteBookKotlinPage
import org.multiplatform.kotfolio.pages.QuestionsAndroidPage as _org_multiplatform_kotfolio_pages_QuestionsAndroidPage
import org.multiplatform.kotfolio.pages.RoomDatabaseAndroidPage as _org_multiplatform_kotfolio_pages_RoomDatabaseAndroidPage
import org.multiplatform.kotfolio.pages.SocketKtorPage as _org_multiplatform_kotfolio_pages_SocketKtorPage
import org.multiplatform.kotfolio.pages.androidstudio.GradleAndroidStudioPage as _org_multiplatform_kotfolio_pages_androidstudio_GradleAndroidStudioPage
import org.multiplatform.kotfolio.pages.androidstudio.MacroAndroidStudioPage as _org_multiplatform_kotfolio_pages_androidstudio_MacroAndroidStudioPage
import org.multiplatform.kotfolio.pages.compose.AdaptiveLayoutComposePage as _org_multiplatform_kotfolio_pages_compose_AdaptiveLayoutComposePage
import org.multiplatform.kotfolio.pages.compose.AnimationComposePage as _org_multiplatform_kotfolio_pages_compose_AnimationComposePage
import org.multiplatform.kotfolio.pages.compose.BasicComposePage as _org_multiplatform_kotfolio_pages_compose_BasicComposePage
import org.multiplatform.kotfolio.pages.compose.BottomSheetComposePage as _org_multiplatform_kotfolio_pages_compose_BottomSheetComposePage
import org.multiplatform.kotfolio.pages.compose.CleanArchitectureMMVIPage as _org_multiplatform_kotfolio_pages_compose_CleanArchitectureMMVIPage
import org.multiplatform.kotfolio.pages.compose.CommonWrapperPage as _org_multiplatform_kotfolio_pages_compose_CommonWrapperPage
import org.multiplatform.kotfolio.pages.compose.ComposeCleanArchitecturePage as _org_multiplatform_kotfolio_pages_compose_ComposeCleanArchitecturePage
import org.multiplatform.kotfolio.pages.compose.ComposeNavigationPage as _org_multiplatform_kotfolio_pages_compose_ComposeNavigationPage
import org.multiplatform.kotfolio.pages.compose.ComposePaginationPage as _org_multiplatform_kotfolio_pages_compose_ComposePaginationPage
import org.multiplatform.kotfolio.pages.compose.ComposePerformancePage as _org_multiplatform_kotfolio_pages_compose_ComposePerformancePage
import org.multiplatform.kotfolio.pages.compose.ComposeQuestionsPage as _org_multiplatform_kotfolio_pages_compose_ComposeQuestionsPage
import org.multiplatform.kotfolio.pages.compose.ComposeStateHostingPage as _org_multiplatform_kotfolio_pages_compose_ComposeStateHostingPage
import org.multiplatform.kotfolio.pages.compose.ComposeUDFPage as _org_multiplatform_kotfolio_pages_compose_ComposeUDFPage
import org.multiplatform.kotfolio.pages.compose.CompositionalLocalsComposePage as _org_multiplatform_kotfolio_pages_compose_CompositionalLocalsComposePage
import org.multiplatform.kotfolio.pages.compose.ModifierComposePage as _org_multiplatform_kotfolio_pages_compose_ModifierComposePage
import org.multiplatform.kotfolio.pages.compose.MultiModuleComposePage as _org_multiplatform_kotfolio_pages_compose_MultiModuleComposePage
import org.multiplatform.kotfolio.pages.compose.PrefStoreComposePage as _org_multiplatform_kotfolio_pages_compose_PrefStoreComposePage
import org.multiplatform.kotfolio.pages.compose.PreviewComposePage as _org_multiplatform_kotfolio_pages_compose_PreviewComposePage
import org.multiplatform.kotfolio.pages.compose.RemoteComposePage as _org_multiplatform_kotfolio_pages_compose_RemoteComposePage
import org.multiplatform.kotfolio.pages.compose.RoomDatabasePage as _org_multiplatform_kotfolio_pages_compose_RoomDatabasePage
import org.multiplatform.kotfolio.pages.compose.ScopedSlotsComposePage as _org_multiplatform_kotfolio_pages_compose_ScopedSlotsComposePage
import org.multiplatform.kotfolio.pages.compose.SideEffectComposePage as _org_multiplatform_kotfolio_pages_compose_SideEffectComposePage
import org.multiplatform.kotfolio.pages.compose.StateManageComposePage as _org_multiplatform_kotfolio_pages_compose_StateManageComposePage
import org.multiplatform.kotfolio.pages.compose.StyleApiComposePage as _org_multiplatform_kotfolio_pages_compose_StyleApiComposePage
import org.multiplatform.kotfolio.pages.compose.`internal`.ComposeLifeCyclePage as _org_multiplatform_kotfolio_pages_compose_internal_ComposeLifeCyclePage
import org.multiplatform.kotfolio.pages.compose.`internal`.InternalRenderProcessComposePage as _org_multiplatform_kotfolio_pages_compose_internal_InternalRenderProcessComposePage
import org.multiplatform.kotfolio.pages.compose.`internal`.RuntimeComposePage as _org_multiplatform_kotfolio_pages_compose_internal_RuntimeComposePage
import org.multiplatform.kotfolio.pages.compose.architecture.CompositionArchitectureComposePage as _org_multiplatform_kotfolio_pages_compose_architecture_CompositionArchitectureComposePage
import org.multiplatform.kotfolio.pages.compose.side_effect.AppStateTransformPage as _org_multiplatform_kotfolio_pages_compose_side_effect_AppStateTransformPage
import org.multiplatform.kotfolio.pages.compose.side_effect.DerivedStateOfPage as _org_multiplatform_kotfolio_pages_compose_side_effect_DerivedStateOfPage
import org.multiplatform.kotfolio.pages.compose.side_effect.DisposableEffectPage as _org_multiplatform_kotfolio_pages_compose_side_effect_DisposableEffectPage
import org.multiplatform.kotfolio.pages.compose.side_effect.LaunchedEffectPage as _org_multiplatform_kotfolio_pages_compose_side_effect_LaunchedEffectPage
import org.multiplatform.kotfolio.pages.compose.side_effect.ProduceStatePage as _org_multiplatform_kotfolio_pages_compose_side_effect_ProduceStatePage
import org.multiplatform.kotfolio.pages.compose.side_effect.RememberCoroutineScopePage as _org_multiplatform_kotfolio_pages_compose_side_effect_RememberCoroutineScopePage
import org.multiplatform.kotfolio.pages.compose.side_effect.RememberObserverPage as _org_multiplatform_kotfolio_pages_compose_side_effect_RememberObserverPage
import org.multiplatform.kotfolio.pages.compose.side_effect.RememberPage as _org_multiplatform_kotfolio_pages_compose_side_effect_RememberPage
import org.multiplatform.kotfolio.pages.compose.side_effect.RememberSaveablePage as _org_multiplatform_kotfolio_pages_compose_side_effect_RememberSaveablePage
import org.multiplatform.kotfolio.pages.compose.side_effect.RememberSerializablePage as _org_multiplatform_kotfolio_pages_compose_side_effect_RememberSerializablePage
import org.multiplatform.kotfolio.pages.compose.side_effect.RememberUpdatedStatePage as _org_multiplatform_kotfolio_pages_compose_side_effect_RememberUpdatedStatePage
import org.multiplatform.kotfolio.pages.compose.side_effect.RetainPage as _org_multiplatform_kotfolio_pages_compose_side_effect_RetainPage
import org.multiplatform.kotfolio.pages.compose.side_effect.SaveableStateHolderPage as _org_multiplatform_kotfolio_pages_compose_side_effect_SaveableStateHolderPage
import org.multiplatform.kotfolio.pages.compose.side_effect.SavedStatePage as _org_multiplatform_kotfolio_pages_compose_side_effect_SavedStatePage
import org.multiplatform.kotfolio.pages.compose.side_effect.SaverCustomPage as _org_multiplatform_kotfolio_pages_compose_side_effect_SaverCustomPage
import org.multiplatform.kotfolio.pages.compose.side_effect.SideEffectPage as _org_multiplatform_kotfolio_pages_compose_side_effect_SideEffectPage
import org.multiplatform.kotfolio.pages.compose.side_effect.SnapshotFlowPage as _org_multiplatform_kotfolio_pages_compose_side_effect_SnapshotFlowPage
import org.multiplatform.kotfolio.pages.compose.side_effect.StabilityPage as _org_multiplatform_kotfolio_pages_compose_side_effect_StabilityPage
import org.multiplatform.kotfolio.pages.compose.viewmodel.ViewModelAutoCloseablePage as _org_multiplatform_kotfolio_pages_compose_viewmodel_ViewModelAutoCloseablePage
import org.multiplatform.kotfolio.pages.compose.viewmodel.ViewModelComposePage as _org_multiplatform_kotfolio_pages_compose_viewmodel_ViewModelComposePage
import org.multiplatform.kotfolio.pages.coroutines.BasicCoroutinesPage as _org_multiplatform_kotfolio_pages_coroutines_BasicCoroutinesPage
import org.multiplatform.kotfolio.pages.coroutines.ChannelPage as _org_multiplatform_kotfolio_pages_coroutines_ChannelPage
import org.multiplatform.kotfolio.pages.coroutines.ContextCancellationPage as _org_multiplatform_kotfolio_pages_coroutines_ContextCancellationPage
import org.multiplatform.kotfolio.pages.coroutines.ConvertFlowPage as _org_multiplatform_kotfolio_pages_coroutines_ConvertFlowPage
import org.multiplatform.kotfolio.pages.coroutines.CreatePage as _org_multiplatform_kotfolio_pages_coroutines_CreatePage
import org.multiplatform.kotfolio.pages.coroutines.DispatchersPage as _org_multiplatform_kotfolio_pages_coroutines_DispatchersPage
import org.multiplatform.kotfolio.pages.coroutines.FatalMistakePage as _org_multiplatform_kotfolio_pages_coroutines_FatalMistakePage
import org.multiplatform.kotfolio.pages.coroutines.FilterPage as _org_multiplatform_kotfolio_pages_coroutines_FilterPage
import org.multiplatform.kotfolio.pages.coroutines.FlowBasicPage as _org_multiplatform_kotfolio_pages_coroutines_FlowBasicPage
import org.multiplatform.kotfolio.pages.coroutines.FlowBuildersPage as _org_multiplatform_kotfolio_pages_coroutines_FlowBuildersPage
import org.multiplatform.kotfolio.pages.coroutines.FlowCombinePage as _org_multiplatform_kotfolio_pages_coroutines_FlowCombinePage
import org.multiplatform.kotfolio.pages.coroutines.FlowCreatePage as _org_multiplatform_kotfolio_pages_coroutines_FlowCreatePage
import org.multiplatform.kotfolio.pages.coroutines.FlowOnPage as _org_multiplatform_kotfolio_pages_coroutines_FlowOnPage
import org.multiplatform.kotfolio.pages.coroutines.QuestionsCoroutinesPage as _org_multiplatform_kotfolio_pages_coroutines_QuestionsCoroutinesPage
import org.multiplatform.kotfolio.pages.coroutines.SemaphorePage as _org_multiplatform_kotfolio_pages_coroutines_SemaphorePage
import org.multiplatform.kotfolio.pages.coroutines.SingleQuestionsPage as _org_multiplatform_kotfolio_pages_coroutines_SingleQuestionsPage
import org.multiplatform.kotfolio.pages.coroutines.StateSharedFlowPage as _org_multiplatform_kotfolio_pages_coroutines_StateSharedFlowPage
import org.multiplatform.kotfolio.pages.coroutines.SuspendPage as _org_multiplatform_kotfolio_pages_coroutines_SuspendPage
import org.multiplatform.kotfolio.pages.flutter.AsynchronousPage as _org_multiplatform_kotfolio_pages_flutter_AsynchronousPage
import org.multiplatform.kotfolio.pages.flutter.BLoCPage as _org_multiplatform_kotfolio_pages_flutter_BLoCPage
import org.multiplatform.kotfolio.pages.flutter.BasicPage as _org_multiplatform_kotfolio_pages_flutter_BasicPage
import org.multiplatform.kotfolio.pages.flutter.CleanArchitecturePage as _org_multiplatform_kotfolio_pages_flutter_CleanArchitecturePage
import org.multiplatform.kotfolio.pages.flutter.DartNullSafetyPage as _org_multiplatform_kotfolio_pages_flutter_DartNullSafetyPage
import org.multiplatform.kotfolio.pages.flutter.FirebasePage as _org_multiplatform_kotfolio_pages_flutter_FirebasePage
import org.multiplatform.kotfolio.pages.flutter.FreezedFPage as _org_multiplatform_kotfolio_pages_flutter_FreezedFPage
import org.multiplatform.kotfolio.pages.flutter.GetItPage as _org_multiplatform_kotfolio_pages_flutter_GetItPage
import org.multiplatform.kotfolio.pages.flutter.IsolatePage as _org_multiplatform_kotfolio_pages_flutter_IsolatePage
import org.multiplatform.kotfolio.pages.flutter.PluginPage as _org_multiplatform_kotfolio_pages_flutter_PluginPage
import org.multiplatform.kotfolio.pages.flutter.QuestionsPage as _org_multiplatform_kotfolio_pages_flutter_QuestionsPage
import org.multiplatform.kotfolio.pages.flutter.SolidPrinciplesPage as _org_multiplatform_kotfolio_pages_flutter_SolidPrinciplesPage
import org.multiplatform.kotfolio.pages.flutter.WidgetLifeCyclePage as _org_multiplatform_kotfolio_pages_flutter_WidgetLifeCyclePage
import org.multiplatform.kotfolio.pages.flutter.getXPage as _org_multiplatform_kotfolio_pages_flutter_getXPage
import org.multiplatform.kotfolio.pages.homePage as _org_multiplatform_kotfolio_pages_homePage
import org.multiplatform.kotfolio.pages.java.AbstractClassJavaPage as _org_multiplatform_kotfolio_pages_java_AbstractClassJavaPage
import org.multiplatform.kotfolio.pages.java.InheritanceJavaPage as _org_multiplatform_kotfolio_pages_java_InheritanceJavaPage
import org.multiplatform.kotfolio.pages.java.InterfaceJavaPage as _org_multiplatform_kotfolio_pages_java_InterfaceJavaPage
import org.multiplatform.kotfolio.pages.java.ThreadJavaPage as _org_multiplatform_kotfolio_pages_java_ThreadJavaPage
import org.multiplatform.kotfolio.pages.kids.CommunicatePage as _org_multiplatform_kotfolio_pages_kids_CommunicatePage
import org.multiplatform.kotfolio.pages.kids.KidsAgricultureIndiaPage as _org_multiplatform_kotfolio_pages_kids_KidsAgricultureIndiaPage
import org.multiplatform.kotfolio.pages.kids.KidsAirPage as _org_multiplatform_kotfolio_pages_kids_KidsAirPage
import org.multiplatform.kotfolio.pages.kids.KidsAnalogyAlphabetPage as _org_multiplatform_kotfolio_pages_kids_KidsAnalogyAlphabetPage
import org.multiplatform.kotfolio.pages.kids.KidsAnimalsPage as _org_multiplatform_kotfolio_pages_kids_KidsAnimalsPage
import org.multiplatform.kotfolio.pages.kids.KidsBodyPage as _org_multiplatform_kotfolio_pages_kids_KidsBodyPage
import org.multiplatform.kotfolio.pages.kids.KidsEarthPage as _org_multiplatform_kotfolio_pages_kids_KidsEarthPage
import org.multiplatform.kotfolio.pages.kids.KidsFamilyPage as _org_multiplatform_kotfolio_pages_kids_KidsFamilyPage
import org.multiplatform.kotfolio.pages.kids.KidsFoodAndHealthPage as _org_multiplatform_kotfolio_pages_kids_KidsFoodAndHealthPage
import org.multiplatform.kotfolio.pages.kids.KidsFoodPage as _org_multiplatform_kotfolio_pages_kids_KidsFoodPage
import org.multiplatform.kotfolio.pages.kids.KidsIndianFestivalPage as _org_multiplatform_kotfolio_pages_kids_KidsIndianFestivalPage
import org.multiplatform.kotfolio.pages.kids.KidsLivingSeasonsPage as _org_multiplatform_kotfolio_pages_kids_KidsLivingSeasonsPage
import org.multiplatform.kotfolio.pages.kids.KidsOurHelperPage as _org_multiplatform_kotfolio_pages_kids_KidsOurHelperPage
import org.multiplatform.kotfolio.pages.kids.KidsOurSchoolPage as _org_multiplatform_kotfolio_pages_kids_KidsOurSchoolPage
import org.multiplatform.kotfolio.pages.kids.KidsPlantsMakeFoodPage as _org_multiplatform_kotfolio_pages_kids_KidsPlantsMakeFoodPage
import org.multiplatform.kotfolio.pages.kids.KidsPlantsPage as _org_multiplatform_kotfolio_pages_kids_KidsPlantsPage
import org.multiplatform.kotfolio.pages.kids.KidsPronounce as _org_multiplatform_kotfolio_pages_kids_KidsPronounce
import org.multiplatform.kotfolio.pages.kids.KidsReaderPage as _org_multiplatform_kotfolio_pages_kids_KidsReaderPage
import org.multiplatform.kotfolio.pages.kids.KidsShelterPage as _org_multiplatform_kotfolio_pages_kids_KidsShelterPage
import org.multiplatform.kotfolio.pages.kids.KidsSkyAbovePage as _org_multiplatform_kotfolio_pages_kids_KidsSkyAbovePage
import org.multiplatform.kotfolio.pages.kids.KidsSoilPage as _org_multiplatform_kotfolio_pages_kids_KidsSoilPage
import org.multiplatform.kotfolio.pages.kids.KidsSpeechFlowersPage as _org_multiplatform_kotfolio_pages_kids_KidsSpeechFlowersPage
import org.multiplatform.kotfolio.pages.kids.KidsStoriesPage as _org_multiplatform_kotfolio_pages_kids_KidsStoriesPage
import org.multiplatform.kotfolio.pages.kids.KidsUsefulPlacesPage as _org_multiplatform_kotfolio_pages_kids_KidsUsefulPlacesPage
import org.multiplatform.kotfolio.pages.kids.KidsVisitPlacesPage as _org_multiplatform_kotfolio_pages_kids_KidsVisitPlacesPage
import org.multiplatform.kotfolio.pages.kids.KidsWaterPage as _org_multiplatform_kotfolio_pages_kids_KidsWaterPage
import org.multiplatform.kotfolio.pages.kids.KidsWeatherPage as _org_multiplatform_kotfolio_pages_kids_KidsWeatherPage
import org.multiplatform.kotfolio.pages.kids.RiverSystemPage as _org_multiplatform_kotfolio_pages_kids_RiverSystemPage
import org.multiplatform.kotfolio.pages.kids.SolarSystemKidsPage as _org_multiplatform_kotfolio_pages_kids_SolarSystemKidsPage
import org.multiplatform.kotfolio.pages.kids.dictation.KidsAirPage as _org_multiplatform_kotfolio_pages_kids_dictation_KidsAirPage
import org.multiplatform.kotfolio.pages.kids.english.VerbBasicPage as _org_multiplatform_kotfolio_pages_kids_english_VerbBasicPage
import org.multiplatform.kotfolio.pages.kids.exam.grade2.CanReadPage as _org_multiplatform_kotfolio_pages_kids_exam_grade2_CanReadPage
import org.multiplatform.kotfolio.pages.kids.exam.grade2.Passages2 as _org_multiplatform_kotfolio_pages_kids_exam_grade2_Passages2
import org.multiplatform.kotfolio.pages.kids.grade_3.Grade3BodyPage as _org_multiplatform_kotfolio_pages_kids_grade_3_Grade3BodyPage
import org.multiplatform.kotfolio.pages.kids.hirva.result.Result2Page as _org_multiplatform_kotfolio_pages_kids_hirva_result_Result2Page
import org.multiplatform.kotfolio.pages.kids.maths.Kids2PlaceFaceValuePage as _org_multiplatform_kotfolio_pages_kids_maths_Kids2PlaceFaceValuePage
import org.multiplatform.kotfolio.pages.kids.maths.KidsBasicMathPage as _org_multiplatform_kotfolio_pages_kids_maths_KidsBasicMathPage
import org.multiplatform.kotfolio.pages.kids.maths.MathOrdinalNumberPage as _org_multiplatform_kotfolio_pages_kids_maths_MathOrdinalNumberPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.AdjectivesPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_AdjectivesPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.CanReadPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_CanReadPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.ComprehensionPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_ComprehensionPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.DoubleTroublePage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_DoubleTroublePage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.GoodPlayPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_GoodPlayPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.LittleTurtlePage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_LittleTurtlePage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.MagicPlayhousePage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_MagicPlayhousePage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.MasonPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_MasonPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.StoryPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_StoryPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.TucketBucketPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_TucketBucketPage
import org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2.WigglyToothPage as _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_WigglyToothPage
import org.multiplatform.kotfolio.pages.kmm.BasicKMMPage as _org_multiplatform_kotfolio_pages_kmm_BasicKMMPage
import org.multiplatform.kotfolio.pages.kmm.KMMDecomposePage as _org_multiplatform_kotfolio_pages_kmm_KMMDecomposePage
import org.multiplatform.kotfolio.pages.kmm.KMMNSUserDefaultsPage as _org_multiplatform_kotfolio_pages_kmm_KMMNSUserDefaultsPage
import org.multiplatform.kotfolio.pages.kmm.KMPBasicComponentPage as _org_multiplatform_kotfolio_pages_kmm_KMPBasicComponentPage
import org.multiplatform.kotfolio.pages.kmm.KMPFirebasePage as _org_multiplatform_kotfolio_pages_kmm_KMPFirebasePage
import org.multiplatform.kotfolio.pages.kmm.KMPLogPage as _org_multiplatform_kotfolio_pages_kmm_KMPLogPage
import org.multiplatform.kotfolio.pages.kmm.KMPMultiplatformSettingsPage as _org_multiplatform_kotfolio_pages_kmm_KMPMultiplatformSettingsPage
import org.multiplatform.kotfolio.pages.kmm.KMPPluginPage as _org_multiplatform_kotfolio_pages_kmm_KMPPluginPage
import org.multiplatform.kotfolio.pages.kmm.KMPRealmPage as _org_multiplatform_kotfolio_pages_kmm_KMPRealmPage
import org.multiplatform.kotfolio.pages.kmm.KMPRoomPage as _org_multiplatform_kotfolio_pages_kmm_KMPRoomPage
import org.multiplatform.kotfolio.pages.kmm.KMPValidationFormZPage as _org_multiplatform_kotfolio_pages_kmm_KMPValidationFormZPage
import org.multiplatform.kotfolio.pages.kmm.KeyStorageKMPPage as _org_multiplatform_kotfolio_pages_kmm_KeyStorageKMPPage
import org.multiplatform.kotfolio.pages.kmm.QRScannerKMMPage as _org_multiplatform_kotfolio_pages_kmm_QRScannerKMMPage
import org.multiplatform.kotfolio.pages.kmm.Sandwich as _org_multiplatform_kotfolio_pages_kmm_Sandwich
import org.multiplatform.kotfolio.pages.kmm.SecureStorageKMPPage as _org_multiplatform_kotfolio_pages_kmm_SecureStorageKMPPage
import org.multiplatform.kotfolio.pages.kobweb.KobWebAPIPage as _org_multiplatform_kotfolio_pages_kobweb_KobWebAPIPage
import org.multiplatform.kotfolio.pages.kobweb.KobWebBasicPage as _org_multiplatform_kotfolio_pages_kobweb_KobWebBasicPage
import org.multiplatform.kotfolio.pages.koin.KoinAnnotationsPage as _org_multiplatform_kotfolio_pages_koin_KoinAnnotationsPage
import org.multiplatform.kotfolio.pages.koin.KoinBasicPage as _org_multiplatform_kotfolio_pages_koin_KoinBasicPage
import org.multiplatform.kotfolio.pages.koin.KoinNavigationPage as _org_multiplatform_kotfolio_pages_koin_KoinNavigationPage
import org.multiplatform.kotfolio.pages.koin.KoinPage as _org_multiplatform_kotfolio_pages_koin_KoinPage
import org.multiplatform.kotfolio.pages.koin.KoinSharedPage as _org_multiplatform_kotfolio_pages_koin_KoinSharedPage
import org.multiplatform.kotfolio.pages.kotlin.FilterCollectionPage as _org_multiplatform_kotfolio_pages_kotlin_FilterCollectionPage
import org.multiplatform.kotfolio.pages.kotlin.HigherOrderFunctionsKotlinPage as _org_multiplatform_kotfolio_pages_kotlin_HigherOrderFunctionsKotlinPage
import org.multiplatform.kotfolio.pages.kotlin.MutexPage as _org_multiplatform_kotfolio_pages_kotlin_MutexPage
import org.multiplatform.kotfolio.pages.kotlin.QuestionsKotlinPage as _org_multiplatform_kotfolio_pages_kotlin_QuestionsKotlinPage
import org.multiplatform.kotfolio.pages.kotlin.design_pattern.DesignPatternsPage as _org_multiplatform_kotfolio_pages_kotlin_design_pattern_DesignPatternsPage
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature2_0_20Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature2_0_20Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_0Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_0Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_1_0Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_1_0Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_2_0Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_2_0Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_3_0Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_3_0Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_3_20Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_3_20Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_4_0_Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_4_0_Page
import org.multiplatform.kotfolio.pages.kotlin.new_feature.NewFeature_2_5_0_beta_1_Page as _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_5_0_beta_1_Page
import org.multiplatform.kotfolio.pages.listing.ChoppingBoardListing as _org_multiplatform_kotfolio_pages_listing_ChoppingBoardListing
import org.multiplatform.kotfolio.pages.listing.ClothDryerVerticalListing as _org_multiplatform_kotfolio_pages_listing_ClothDryerVerticalListing
import org.multiplatform.kotfolio.pages.listing.HydraulicPressMachine as _org_multiplatform_kotfolio_pages_listing_HydraulicPressMachine
import org.multiplatform.kotfolio.pages.listing.KitchenTrolleyMetalListing as _org_multiplatform_kotfolio_pages_listing_KitchenTrolleyMetalListing
import org.multiplatform.kotfolio.pages.listing.LabelCropping as _org_multiplatform_kotfolio_pages_listing_LabelCropping
import org.multiplatform.kotfolio.pages.listing.PaneerPressMakerListing as _org_multiplatform_kotfolio_pages_listing_PaneerPressMakerListing
import org.multiplatform.kotfolio.pages.listing.PlasticSupply as _org_multiplatform_kotfolio_pages_listing_PlasticSupply
import org.multiplatform.kotfolio.pages.listing.SteelSinkOrganiser as _org_multiplatform_kotfolio_pages_listing_SteelSinkOrganiser
import org.multiplatform.kotfolio.pages.listing.StepLadderListing as _org_multiplatform_kotfolio_pages_listing_StepLadderListing
import org.multiplatform.kotfolio.pages.listing.WallMountedListing as _org_multiplatform_kotfolio_pages_listing_WallMountedListing
import org.multiplatform.kotfolio.pages.listing.WardrobePlasticListing as _org_multiplatform_kotfolio_pages_listing_WardrobePlasticListing
import org.multiplatform.kotfolio.pages.portfolio.MosecPage as _org_multiplatform_kotfolio_pages_portfolio_MosecPage
import org.multiplatform.kotfolio.pages.shared.ViewModelPage as _org_multiplatform_kotfolio_pages_shared_ViewModelPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Multiplatform Developer"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "org.multiplatform.kotfolio.layout.NeoLayout",
        ) { pageCtx, pageMethod -> 
            _org_multiplatform_kotfolio_layout_NeoLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "org.multiplatform.kotfolio.layout.PageLayout",
        ) { pageCtx, pageMethod -> 
            _org_multiplatform_kotfolio_layout_PageLayout {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "org.multiplatform.kotfolio.layout.PageLayout",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_homePage()
        }
        ctx.router.register(
            "/android_communicate_fragment",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_RoomDatabaseAndroidPage()
        }
        ctx.router.register(
            "/android_questions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_QuestionsAndroidPage()
        }
        ctx.router.register(
            "/androidstudio/gradle",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_androidstudio_GradleAndroidStudioPage()
        }
        ctx.router.register(
            "/androidstudio/macro",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_androidstudio_MacroAndroidStudioPage()
        }
        ctx.router.register(
            "/api_calling_rpc",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_APICallingRPCPage()
        }
        ctx.router.register(
            "/business_travel",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_BusinessTravelPage()
        }
        ctx.router.register(
            "/compose/adaptive_layout",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_AdaptiveLayoutComposePage()
        }
        ctx.router.register(
            "/compose/animation",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_AnimationComposePage()
        }
        ctx.router.register(
            "/compose/architecture/composition",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_architecture_CompositionArchitectureComposePage()
        }
        ctx.router.register(
            "/compose/basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_BasicComposePage()
        }
        ctx.router.register(
            "/compose/bottom_sheet",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_BottomSheetComposePage()
        }
        ctx.router.register(
            "/compose/clean_architecture",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposeCleanArchitecturePage()
        }
        ctx.router.register(
            "/compose/common_wrapper",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_CommonWrapperPage()
        }
        ctx.router.register(
            "/compose/compose_style_api",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_StyleApiComposePage()
        }
        ctx.router.register(
            "/compose/compositional_locals",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_CompositionalLocalsComposePage()
        }
        ctx.router.register(
            "/compose/internal/lifecycle",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_internal_ComposeLifeCyclePage()
        }
        ctx.router.register(
            "/compose/internal/render_process",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_internal_InternalRenderProcessComposePage()
        }
        ctx.router.register(
            "/compose/internal/runtime",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_internal_RuntimeComposePage()
        }
        ctx.router.register(
            "/compose/modifier",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ModifierComposePage()
        }
        ctx.router.register(
            "/compose/multi_module",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_MultiModuleComposePage()
        }
        ctx.router.register(
            "/compose/mvi",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_CleanArchitectureMMVIPage()
        }
        ctx.router.register(
            "/compose/navigation",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposeNavigationPage()
        }
        ctx.router.register(
            "/compose/pagination",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposePaginationPage()
        }
        ctx.router.register(
            "/compose/performance",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposePerformancePage()
        }
        ctx.router.register(
            "/compose/pref_store",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_PrefStoreComposePage()
        }
        ctx.router.register(
            "/compose/preview",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_PreviewComposePage()
        }
        ctx.router.register(
            "/compose/questions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposeQuestionsPage()
        }
        ctx.router.register(
            "/compose/remote",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_RemoteComposePage()
        }
        ctx.router.register(
            "/compose/room",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_RoomDatabasePage()
        }
        ctx.router.register(
            "/compose/scoped_slots",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ScopedSlotsComposePage()
        }
        ctx.router.register(
            "/compose/side_effect",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_SideEffectComposePage()
        }
        ctx.router.register(
            "/compose/side_effect/appstatetransform",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_AppStateTransformPage()
        }
        ctx.router.register(
            "/compose/side_effect/derivedstateof",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_DerivedStateOfPage()
        }
        ctx.router.register(
            "/compose/side_effect/disposable_effect",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_DisposableEffectPage()
        }
        ctx.router.register(
            "/compose/side_effect/launched_effect",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_LaunchedEffectPage()
        }
        ctx.router.register(
            "/compose/side_effect/produce_state",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_ProduceStatePage()
        }
        ctx.router.register(
            "/compose/side_effect/remember",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RememberPage()
        }
        ctx.router.register(
            "/compose/side_effect/remember_coroutine_scope",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RememberCoroutineScopePage()
        }
        ctx.router.register(
            "/compose/side_effect/remember_observer",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RememberObserverPage()
        }
        ctx.router.register(
            "/compose/side_effect/remember_saveable",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RememberSaveablePage()
        }
        ctx.router.register(
            "/compose/side_effect/remember_serializable",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RememberSerializablePage()
        }
        ctx.router.register(
            "/compose/side_effect/remember_updated_state",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RememberUpdatedStatePage()
        }
        ctx.router.register(
            "/compose/side_effect/retain",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_RetainPage()
        }
        ctx.router.register(
            "/compose/side_effect/saveable_state_holder",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_SaveableStateHolderPage()
        }
        ctx.router.register(
            "/compose/side_effect/savedstate",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_SavedStatePage()
        }
        ctx.router.register(
            "/compose/side_effect/saver_custom",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_SaverCustomPage()
        }
        ctx.router.register(
            "/compose/side_effect/side_effect",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_SideEffectPage()
        }
        ctx.router.register(
            "/compose/side_effect/snapshot_flow",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_SnapshotFlowPage()
        }
        ctx.router.register(
            "/compose/side_effect/stability",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_side_effect_StabilityPage()
        }
        ctx.router.register(
            "/compose/state_hosting",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposeStateHostingPage()
        }
        ctx.router.register(
            "/compose/state_manage",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_StateManageComposePage()
        }
        ctx.router.register(
            "/compose/udf",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_ComposeUDFPage()
        }
        ctx.router.register(
            "/compose/viewmodel/autocloseable",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_viewmodel_ViewModelAutoCloseablePage()
        }
        ctx.router.register(
            "/compose/viewmodel/viewmodel",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_compose_viewmodel_ViewModelComposePage()
        }
        ctx.router.register(
            "/constraintlogin",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_ConstraintLogin()
        }
        ctx.router.register(
            "/coroutines/basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_BasicCoroutinesPage()
        }
        ctx.router.register(
            "/coroutines/channel",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_ChannelPage()
        }
        ctx.router.register(
            "/coroutines/context_cancellation",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_ContextCancellationPage()
        }
        ctx.router.register(
            "/coroutines/convert_flow",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_ConvertFlowPage()
        }
        ctx.router.register(
            "/coroutines/create",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_CreatePage()
        }
        ctx.router.register(
            "/coroutines/dispatchers",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_DispatchersPage()
        }
        ctx.router.register(
            "/coroutines/fatal_mistake",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FatalMistakePage()
        }
        ctx.router.register(
            "/coroutines/filter",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FilterPage()
        }
        ctx.router.register(
            "/coroutines/flow_basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FlowBasicPage()
        }
        ctx.router.register(
            "/coroutines/flow_builders",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FlowBuildersPage()
        }
        ctx.router.register(
            "/coroutines/flow_combine",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FlowCombinePage()
        }
        ctx.router.register(
            "/coroutines/flow_create",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FlowCreatePage()
        }
        ctx.router.register(
            "/coroutines/flow_on",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_FlowOnPage()
        }
        ctx.router.register(
            "/coroutines/questions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_QuestionsCoroutinesPage()
        }
        ctx.router.register(
            "/coroutines/semaphore",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_SemaphorePage()
        }
        ctx.router.register(
            "/coroutines/single_questions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_SingleQuestionsPage()
        }
        ctx.router.register(
            "/coroutines/state_shared_flow",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_StateSharedFlowPage()
        }
        ctx.router.register(
            "/coroutines/suspend",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_coroutines_SuspendPage()
        }
        ctx.router.register(
            "/di_hilt",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_HiltDiPage()
        }
        ctx.router.register(
            "/di_kotlin_inject",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_KotlinInjectDiPage()
        }
        ctx.router.register(
            "/exposed",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_ExposedBackendPage()
        }
        ctx.router.register(
            "/flutter/asynchronous",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_AsynchronousPage()
        }
        ctx.router.register(
            "/flutter/basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_BasicPage()
        }
        ctx.router.register(
            "/flutter/bloc",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_BLoCPage()
        }
        ctx.router.register(
            "/flutter/clean_architecture",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_CleanArchitecturePage()
        }
        ctx.router.register(
            "/flutter/firebase",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_FirebasePage()
        }
        ctx.router.register(
            "/flutter/freezed",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_FreezedFPage()
        }
        ctx.router.register(
            "/flutter/get_it",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_GetItPage()
        }
        ctx.router.register(
            "/flutter/getx",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_getXPage()
        }
        ctx.router.register(
            "/flutter/isolate",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_IsolatePage()
        }
        ctx.router.register(
            "/flutter/null_safety",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_DartNullSafetyPage()
        }
        ctx.router.register(
            "/flutter/plugin",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_PluginPage()
        }
        ctx.router.register(
            "/flutter/questions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_QuestionsPage()
        }
        ctx.router.register(
            "/flutter/solid_principles",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_SolidPrinciplesPage()
        }
        ctx.router.register(
            "/flutter/widget_lifecycle",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_flutter_WidgetLifeCyclePage()
        }
        ctx.router.register(
            "/java/abstract_class",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_java_AbstractClassJavaPage()
        }
        ctx.router.register(
            "/java/inheritance",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_java_InheritanceJavaPage()
        }
        ctx.router.register(
            "/java/interface",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_java_InterfaceJavaPage()
        }
        ctx.router.register(
            "/java/thread",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_java_ThreadJavaPage()
        }
        ctx.router.register(
            "/kids/agriculture_india",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsAgricultureIndiaPage()
        }
        ctx.router.register(
            "/kids/air",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsAirPage()
        }
        ctx.router.register(
            "/kids/analogy_alphabet",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsAnalogyAlphabetPage()
        }
        ctx.router.register(
            "/kids/animals",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsAnimalsPage()
        }
        ctx.router.register(
            "/kids/body",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsBodyPage()
        }
        ctx.router.register(
            "/kids/communicate",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_CommunicatePage()
        }
        ctx.router.register(
            "/kids/dictation/dictation_2",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_dictation_KidsAirPage()
        }
        ctx.router.register(
            "/kids/earth",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsEarthPage()
        }
        ctx.router.register(
            "/kids/english/verb",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_english_VerbBasicPage()
        }
        ctx.router.register(
            "/kids/exam/grade2/english1",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_exam_grade2_CanReadPage()
        }
        ctx.router.register(
            "/kids/exam/grade2/passage",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_exam_grade2_Passages2()
        }
        ctx.router.register(
            "/kids/family",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsFamilyPage()
        }
        ctx.router.register(
            "/kids/flowers",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsSpeechFlowersPage()
        }
        ctx.router.register(
            "/kids/food",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsFoodPage()
        }
        ctx.router.register(
            "/kids/food_and_health",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsFoodAndHealthPage()
        }
        ctx.router.register(
            "/kids/grade_3/human_body",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_grade_3_Grade3BodyPage()
        }
        ctx.router.register(
            "/kids/hirva/result/grade2",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_hirva_result_Result2Page()
        }
        ctx.router.register(
            "/kids/indian_festival",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsIndianFestivalPage()
        }
        ctx.router.register(
            "/kids/living_seasons",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsLivingSeasonsPage()
        }
        ctx.router.register(
            "/kids/maths/basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_maths_KidsBasicMathPage()
        }
        ctx.router.register(
            "/kids/maths/ordinal_number",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_maths_MathOrdinalNumberPage()
        }
        ctx.router.register(
            "/kids/maths/place_face_value",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_maths_Kids2PlaceFaceValuePage()
        }
        ctx.router.register(
            "/kids/our_helper",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsOurHelperPage()
        }
        ctx.router.register(
            "/kids/our_school",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsOurSchoolPage()
        }
        ctx.router.register(
            "/kids/plants",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsPlantsPage()
        }
        ctx.router.register(
            "/kids/plants_make_food",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsPlantsMakeFoodPage()
        }
        ctx.router.register(
            "/kids/pronounce",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsPronounce()
        }
        ctx.router.register(
            "/kids/reader",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsReaderPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/adjectives",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_AdjectivesPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/can_read",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_CanReadPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/comprehension",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_ComprehensionPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/double_trouble",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_DoubleTroublePage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/good_play",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_GoodPlayPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/little_turtle",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_LittleTurtlePage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/magic_playhouse",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_MagicPlayhousePage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/mason",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_MasonPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/story",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_StoryPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/tucket_bucket",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_TucketBucketPage()
        }
        ctx.router.register(
            "/kids/ride_to_read/class_2/wiggly_tooth",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_ride_to_read_class_2_WigglyToothPage()
        }
        ctx.router.register(
            "/kids/river_system",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_RiverSystemPage()
        }
        ctx.router.register(
            "/kids/shelter",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsShelterPage()
        }
        ctx.router.register(
            "/kids/sky_above",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsSkyAbovePage()
        }
        ctx.router.register(
            "/kids/soil",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsSoilPage()
        }
        ctx.router.register(
            "/kids/solar_system",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_SolarSystemKidsPage()
        }
        ctx.router.register(
            "/kids/stories",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsStoriesPage()
        }
        ctx.router.register(
            "/kids/useful_places",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsUsefulPlacesPage()
        }
        ctx.router.register(
            "/kids/visit_places",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsVisitPlacesPage()
        }
        ctx.router.register(
            "/kids/water",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsWaterPage()
        }
        ctx.router.register(
            "/kids/weather",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kids_KidsWeatherPage()
        }
        ctx.router.register(
            "/kmm/basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_BasicKMMPage()
        }
        ctx.router.register(
            "/kmm/basic_component",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPBasicComponentPage()
        }
        ctx.router.register(
            "/kmm/decompose",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMMDecomposePage()
        }
        ctx.router.register(
            "/kmm/firebase",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPFirebasePage()
        }
        ctx.router.register(
            "/kmm/formz_validation",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPValidationFormZPage()
        }
        ctx.router.register(
            "/kmm/key_storage",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KeyStorageKMPPage()
        }
        ctx.router.register(
            "/kmm/log",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPLogPage()
        }
        ctx.router.register(
            "/kmm/multiplatform_settings",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPMultiplatformSettingsPage()
        }
        ctx.router.register(
            "/kmm/ns_user_defaults",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMMNSUserDefaultsPage()
        }
        ctx.router.register(
            "/kmm/plugin",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPPluginPage()
        }
        ctx.router.register(
            "/kmm/qr_scanner",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_QRScannerKMMPage()
        }
        ctx.router.register(
            "/kmm/realm",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPRealmPage()
        }
        ctx.router.register(
            "/kmm/room",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_KMPRoomPage()
        }
        ctx.router.register(
            "/kmm/sandwich",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_Sandwich()
        }
        ctx.router.register(
            "/kmm/secure_storage",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kmm_SecureStorageKMPPage()
        }
        ctx.router.register(
            "/kobweb/kobweb_api",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kobweb_KobWebAPIPage()
        }
        ctx.router.register(
            "/kobweb/kobweb_basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kobweb_KobWebBasicPage()
        }
        ctx.router.register(
            "/koin/annotations",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_koin_KoinAnnotationsPage()
        }
        ctx.router.register(
            "/koin/basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_koin_KoinBasicPage()
        }
        ctx.router.register(
            "/koin/koin",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_koin_KoinPage()
        }
        ctx.router.register(
            "/koin/navigation",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_koin_KoinNavigationPage()
        }
        ctx.router.register(
            "/koin/shared",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_koin_KoinSharedPage()
        }
        ctx.router.register(
            "/kotest",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_KoTestPage()
        }
        ctx.router.register(
            "/kotlin/design_pattern/design_patterns",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_design_pattern_DesignPatternsPage()
        }
        ctx.router.register(
            "/kotlin/filter_collection",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_FilterCollectionPage()
        }
        ctx.router.register(
            "/kotlin/higher_order_functions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_HigherOrderFunctionsKotlinPage()
        }
        ctx.router.register(
            "/kotlin/mutex",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_MutexPage()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.0",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_0Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.0.20",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature2_0_20Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.1.0",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_1_0Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.2.0",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_2_0Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.3.0",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_3_0Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.3.20",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_3_20Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.4.0",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_4_0_Page()
        }
        ctx.router.register(
            "/kotlin/new_feature/2.5.0.beta1",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_new_feature_NewFeature_2_5_0_beta_1_Page()
        }
        ctx.router.register(
            "/kotlin/questions",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_kotlin_QuestionsKotlinPage()
        }
        ctx.router.register(
            "/kotlin_notebook",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_NoteBookKotlinPage()
        }
        ctx.router.register(
            "/ktor",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_KTORPage()
        }
        ctx.router.register(
            "/ktorfit",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_APICallingKtorFitPage()
        }
        ctx.router.register(
            "/listing/chopping_board",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_ChoppingBoardListing()
        }
        ctx.router.register(
            "/listing/cloth_dryer",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_ClothDryerVerticalListing()
        }
        ctx.router.register(
            "/listing/hydraulic_press_machine",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_HydraulicPressMachine()
        }
        ctx.router.register(
            "/listing/kitchen_trolley_metal",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_KitchenTrolleyMetalListing()
        }
        ctx.router.register(
            "/listing/label_cropping",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_LabelCropping()
        }
        ctx.router.register(
            "/listing/paneer_press_maker",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_PaneerPressMakerListing()
        }
        ctx.router.register(
            "/listing/plastic_supply",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_PlasticSupply()
        }
        ctx.router.register(
            "/listing/sink_organiser",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_SteelSinkOrganiser()
        }
        ctx.router.register(
            "/listing/step_ladder",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_StepLadderListing()
        }
        ctx.router.register(
            "/listing/wall_mounted",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_WallMountedListing()
        }
        ctx.router.register(
            "/listing/wardrobe_plastic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_listing_WardrobePlasticListing()
        }
        ctx.router.register(
            "/metro",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_MetroDependencyInjectionPage()
        }
        ctx.router.register(
            "/portfolio/mosec",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_portfolio_MosecPage()
        }
        ctx.router.register(
            "/shared/viewmodel",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_shared_ViewModelPage()
        }
        ctx.router.register(
            "/socket_ktor",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_SocketKtorPage()
        }
        ctx.router.register(
            "/swift_ui_basic_properties",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_BasicPropertiesSwiftUIPage()
        }
        ctx.router.register(
            "/wasm_basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_BasicWasmPage()
        }
        ctx.router.register(
            "/wasm_js_basic",
        ) { pageCtx -> 
            _org_multiplatform_kotfolio_pages_BasicWasmJsPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("page-content", org.multiplatform.kotfolio.layout.PageContentStyle)
        ctx.theme.registerStyle("navigation-item", org.multiplatform.kotfolio.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", org.multiplatform.kotfolio.styles.LogoStyle)
        ctx.theme.registerStyle("social-links", org.multiplatform.kotfolio.styles.SocialLinksStyle)
        ctx.theme.registerStyle("main-button", org.multiplatform.kotfolio.styles.MainButtonStyle)
        ctx.theme.registerStyle("main-image", org.multiplatform.kotfolio.styles.MainImageStyle)
        ctx.theme.registerStyle("about-image", org.multiplatform.kotfolio.styles.AboutImageStyle)
        ctx.theme.registerStyle("about-text", org.multiplatform.kotfolio.styles.AboutTextStyle)
        ctx.theme.registerStyle("back-to-top-button", org.multiplatform.kotfolio.styles.BackToTopButtonStyle)
        ctx.theme.registerStyle("kotlin-code", org.multiplatform.kotfolio.styles.KotlinCodeStyle)
        ctx.theme.registerStyle("check-indicator", org.multiplatform.kotfolio.styles.CheckIndicatorStyle)
        ctx.theme.registerStyle("service-section", org.multiplatform.kotfolio.styles.ServiceSectionStyle)
        ctx.theme.registerStyle("portfolio-section", org.multiplatform.kotfolio.styles.PortfolioSectionStyle)
        ctx.theme.registerStyle("portfolio-arrow-icon", org.multiplatform.kotfolio.styles.PortfolioArrowIconStyle)
        ctx.theme.registerStyle("input", org.multiplatform.kotfolio.styles.InputStyle)
        ctx.theme.registerStyle("header-container", org.multiplatform.kotfolio.components.HeaderContainerStyle)
        ctx.theme.registerStyle("scrolled-header", org.multiplatform.kotfolio.components.ScrolledHeaderStyle)
        ctx.theme.registerStyle("code-block", org.multiplatform.kotfolio.components.CodeBlockStyle)
        ctx.theme.registerVariant("-under-line", org.multiplatform.kotfolio.styles.UnderLineLinkVariant)
        ctx.theme.registerKeyframes("testimonial-marquee-left", org.multiplatform.kotfolio.sections.TestimonialMarqueeLeft)
        ctx.theme.registerKeyframes("testimonial-marquee-right", org.multiplatform.kotfolio.sections.TestimonialMarqueeRight)
        ctx.theme.registerKeyframes("marquee", org.multiplatform.kotfolio.sections.MarqueeKeyframes)
        ctx.theme.registerKeyframes("glint", org.multiplatform.kotfolio.sections.GlintAnim)
        ctx.theme.registerKeyframes("spin", org.multiplatform.kotfolio.components.Spin)
        ctx.theme.registerKeyframes("node-pulse", org.multiplatform.kotfolio.components.NodePulseKeyframes)
        ctx.theme.registerKeyframes("cursor-blink", org.multiplatform.kotfolio.components.CursorBlinkKeyframes)
        ctx.theme.registerKeyframes("train-travel", org.multiplatform.kotfolio.components.TrainTravelKeyframes)
        ctx.theme.registerKeyframes("skill-glow", org.multiplatform.kotfolio.components.SkillGlowKeyframes)
        ctx.theme.registerKeyframes("pill-slide-in", org.multiplatform.kotfolio.components.PillSlideInKeyframes)
        ctx.theme.registerKeyframes("code-window-blink", org.multiplatform.kotfolio.components.CodeWindowBlinkKeyframes)
        org.multiplatform.kotfolio.updateTheme(ctx)
        org.multiplatform.kotfolio.initStyles(ctx)
        org.multiplatform.kotfolio.initSiteStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.multiplatform.kotfolio.myApp {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
